module.exports = __webpack_public_path__ + "static/img/no-create.e6c1d2ac.png";